module.exports = {"120112001":"双新街道","120112100":"咸水沽镇","120112101":"葛沽镇","120112102":"小站镇","120112103":"双港镇","120112104":"辛庄镇","120112106":"双桥河镇","120112107":"八里台镇","120112108":"北闸口镇","120112401":"铁路十八局","120112403":"长青","120112404":"津南开发区东区","120112405":"津南开发区西区","120112407":"海河教育园区","120112500":"双林农场","120112501":"津南国家农业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/120112.json
// module id = 48
// module chunks = 0